import { render, staticRenderFns } from "./ZjxxbglrForm.vue?vue&type=template&id=4c637a46"
import script from "./ZjxxbglrForm.vue?vue&type=script&lang=js"
export * from "./ZjxxbglrForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports